export const settingDataTypes = {
  boolean: 0,
  integer: 1,
  string: 2,
};